import React, { Fragment, useState } from 'react';

import CheckMark    from "../CheckMark";
import OverlayModal from "~/components/overlayModal";
import Description  from "./Description";


const HasCheckInsInRow = ({status})=> {

  const [overlayOpen, setOverlayOpen] = useState(false);

  return  (
    <Fragment>
      <div className="item" onClick={()=> setOverlayOpen(true)}>
        <OverlayModal bottom opened={overlayOpen} onClose={()=> setOverlayOpen(false)}>
          <Description />
        </OverlayModal>
        <CheckMark done={status}  />
        <div>
          <h5> 09. Do 7 Daily Check-ins in a row </h5>
          <p>Reward: <strong>70</strong> points</p>
        </div>
      </div>
    </Fragment>
  )
};

export default HasCheckInsInRow;
